import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { selectProductSpecialOffers } from '@telialt/utils/src/eshopSelectors';

import { SPECIAL_OFFERS_TEST_ID } from '../test-ids';
import { TriggerSpecialOfferModal } from './components/TriggerSpecialOfferModal';
import { SpecialOffersSection, SpecialOffersSectionTitle } from './SpecialOffersBlock.styles';

export const SpecialOffersBlock: FC = () => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const productSpecialOffers = selectProductSpecialOffers(cart);

    if (!productSpecialOffers?.length) {
        return null;
    }

    return (
        <>
            <SpecialOffersSection data-test={SPECIAL_OFFERS_TEST_ID.OFFERS_BLOCK}>
                <SpecialOffersSectionTitle tag="h3" variant="title-100">
                    {t['eshop.product_page.special_offers.title']}
                </SpecialOffersSectionTitle>
                {productSpecialOffers.map((offer, index) => (
                    <TriggerSpecialOfferModal key={index} {...offer} />
                ))}
            </SpecialOffersSection>
        </>
    );
};
